// Main App component

import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ChatDrawer } from './components/chat/ChatDrawer';
import { Home } from './pages/Home';
import { Experience } from './pages/Experience';
import { FitCheck } from './pages/FitCheck';
import { Admin } from './pages/Admin';
import { useCandidateData } from './hooks/useCandidateData';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function AppContent() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { profile } = useCandidateData();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onAskAiClick={() => setIsChatOpen(true)} />

      <div className="flex-1">
        <Routes>
          <Route
            path="/"
            element={<Home onAskAiClick={() => setIsChatOpen(true)} />}
          />
          <Route path="/experience" element={<Experience />} />
          <Route path="/fit-check" element={<FitCheck />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>

      <Footer
        name={profile?.name || 'Xavier Pineda'}
        title={profile?.title || 'Quality Assurance Engineer'}
        websiteUrl={profile?.github_url || 'https://xavi-pi.github.io/xavi-web/index.html'}
        linkedinUrl={profile?.linkedin_url || 'https://www.linkedin.com/in/xavierpineda/'}
      />

      <ChatDrawer isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </div>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
